import React, { useState } from 'react';
import Menu from './menu';
import Sidebar from './sidebar';
import Footer from './footer';
import blogImg from '../assets/blog.jpg'; // Import the image file
import dtone from '../assets/dt1.png'; // Import the image file
import paralympics from '../assets/i.jpeg'; // Import the image file
import { Link, useLocation } from 'react-router-dom';


const Blog = () => {

  return (
    <div>
      <div className="container mt-5">
        <div className="row">
          <div className="col-sm-12 col-lg-3 col-xl-3 col-md-3">
            <Sidebar />
          </div>
          <div className="col-sm-12 col-lg-9 col-xl-9 col-md-9">
            <Menu />
            <div className="bostami-page-content-wrap">
              <section className="">
                <div className="section-wrapper pl-60 pr-60 pt-60">
                  <div className="bostami-page-title-wrap mb-15">
                    <div className="three">
                      <h1 className="">Blogs</h1>
                    </div>
                    
               
                     
                        <div style={{ display: 'flex', marginTop: '20px' }}>
                          <div>
                            <img className="blogimg" src={dtone} alt="Blog" />
                          </div>
                          <div>
                            <h3 className="company">Digital Twin</h3>
                            <p>A digital twin is a virtual representation of an object or system designed to reflect a physical object accurately. It spans the objects lifecycle, is updated from real-time data and uses simulation, machine learning and reasoning to help make decisions.</p>
                            <Link to="/Digitaltwin" >
                            <p style={{ color: '#0076e4', marginTop: '20px' }}>
                              Read More <span className="glyphicon glyphicon-chevron-right"></span>
                            </p></Link>
                          </div>
                        
                        </div>
                        <div style={{ display: 'flex', marginTop: '20px' }}>
                          <div>
                            <img className="blogimg" src={paralympics} alt="Blog" />
                          </div>
                          <div>
                            <h3 className="company">India’s Golden Era in Paralympics: Record-Breaking Wins at Paris 2024</h3>
                            <p>India’s journey in the Paralympics began in 1968 when the country made its debut in the Games. Since then, Indian athletes have steadily progressed, overcoming numerous challenges to reach where they are today. The Paris Paralympics 2024 is a testament to this progress, as India competes with increased confidence and ambition.</p>
                            <Link to="/Paralympics" >
                            <p style={{ color: '#0076e4', marginTop: '20px' }}>
                              Read More <span className="glyphicon glyphicon-chevron-right"></span>
                            </p></Link>
                          </div>
                        </div>
                        <hr />
                     
                 

                    {/* Pagination Buttons 
                    <ul className="pagination">
                      <li className="page-item">
                        <button 
                          onClick={handlePrevious} 
                          className="page-link" 
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPages).keys()].map((number) => (
                        <li key={number} className={`page-item ${currentPage === number + 1 ? 'active' : ''}`}>
                          <button onClick={() => paginate(number + 1)} className="page-link">
                            {number + 1}
                          </button>
                        </li>
                      ))}
                      <li className="page-item">
                        <button 
                          onClick={handleNext} 
                          className="page-link" 
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
*/}
                  </div>
                </div>
              </section>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
